/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {EntityGroupDetailContract} from '../../../../../api/ms-security/contracts/entity-group/entity-group-detail.contract';
import {CodeFilterModel} from '../../../../../shared/filter/code-filter/code-filter.model';
import {EntityGroupDetailDropdownOptionModel} from '../entity-group-detail-dropdown-option.model';
import {EntityGroupDetailSortByEnum} from './entity-group-detail-sort-by.enum';
import {TemplateRef} from '@angular/core';
import {BaseChipSelectorZoneTooltipEnum} from '../../../../../shared/chip-selector/base-chip-selector-zone-tooltip.enum';

export class EntityGroupDetailMapper {
    private constructor() {
    }

    static toCodeFilterModelArray(input: EntityGroupDetailContract[], sortBy = EntityGroupDetailSortByEnum.CODE): CodeFilterModel[] {
        return input?.map(EntityGroupDetailMapper.toCodeFilterModel)
                .sort((a, b) => a?.[sortBy].localeCompare(b?.[sortBy]));
    }

    static toCodeFilterModel(input: EntityGroupDetailContract): CodeFilterModel {
        let output: CodeFilterModel;

        if (input != null) {
            output = {
                code: input.code,
                name: input.name,
                active: input.active,
                checked: true
            };
        }

        return output;
    }

    static toSupplyingPackingPlantDropdownOptionModelArray(input: EntityGroupDetailContract[]): EntityGroupDetailDropdownOptionModel[] {
        return input?.map(EntityGroupDetailMapper.toSupplyingPackingPlantDropdownOptionModel)
                .sort((a, b) => a.value?.code.localeCompare(b.value?.code));
    }

    static toSupplyingPackingPlantDropdownOptionModel(input: EntityGroupDetailContract): EntityGroupDetailDropdownOptionModel {
        let output: EntityGroupDetailDropdownOptionModel;

        if (input != null) {
            output = {
                value: input,
                titleTransform(): string {
                    return `${this.value.code} - ${this.value.name}`;
                },
                tooltipType: BaseChipSelectorZoneTooltipEnum.DYNAMIC
            };
        }

        return output;
    }

    static toTechnicianGroupDropdownOptionModelArray(input: EntityGroupDetailContract[], tooltipTemplate: TemplateRef<unknown>):
            EntityGroupDetailDropdownOptionModel[] {
        return input?.map((value) => EntityGroupDetailMapper.toTechnicianGroupDropdownOptionModel(value, tooltipTemplate))
                .sort((a, b) => a.value?.name.localeCompare(b.value?.name));
    }

    static toTechnicianGroupDropdownOptionModel(input: EntityGroupDetailContract, tooltipTemplate: TemplateRef<unknown>):
            EntityGroupDetailDropdownOptionModel {
        let output: EntityGroupDetailDropdownOptionModel;

        if (input != null) {
            output = {
                value: input,
                titleTransform(): string {
                    return `${this.value.name}`;
                },
                tooltip: tooltipTemplate,
                tooltipType: BaseChipSelectorZoneTooltipEnum.STATIC
            };
        }

        return output;
    }

    static toSupplierDropdownOptionModelArray(input: EntityGroupDetailContract[]):
            EntityGroupDetailDropdownOptionModel[] {
        return input?.map((value) => EntityGroupDetailMapper.toSupplierDropdownOptionModel(value))
                .sort((a, b) => a.value?.name.localeCompare(b.value?.name));
    }

    static toSupplierDropdownOptionModel(input: EntityGroupDetailContract):
            EntityGroupDetailDropdownOptionModel {
        let output: EntityGroupDetailDropdownOptionModel;

        if (input != null) {
            output = {
                value: input,
                titleTransform(): string {
                    return `${this.value.code} - ${this.value.name}`;
                },
                tooltipType: BaseChipSelectorZoneTooltipEnum.DYNAMIC
            };
        }

        return output;
    }
}
